import {createFeatureSelector} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import { NexiaObjectLinksState } from './reducer/nexia-object-links.reducer';


export const selectNexiaObjectLinksFeature = createFeatureSelector<NexiaObjectLinksState>(StoreKeys.NEXIA_OBJECT_LINKS);
